import Tabs from './components/tabs'

$(document).ready(function () {
    // carousel Team
    if($('.especes').length > 0) {
     
      new Tabs();
      $( ".especes_row" ).each(function() {
        var id_carousel = $(this).find('.carousel-animals').attr('id')
        var id_dots = $(this).find('.dots-animals').attr('id')
        var id_prev = $(this).find('.glider-prev').attr('id')
        var id_next = $(this).find('.glider-next').attr('id')
        const carouselEspeces = document.querySelector('#'+id_carousel)
        if (carouselEspeces) {
          new Glider(carouselEspeces, {
            dots: '#'+id_dots,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: {
              prev: '#'+id_prev,
              next: '#'+id_next
            },
            draggable: true,
            responsive: [
              {
                breakpoint: 900,
                settings: {
                  slidesToShow: 4.3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }
            ]
          })
        }
        if(($(this).find('#'+id_dots).children().length < 2 )) {
          $(this).find(".glider__container-dots").hide();
          $(this).find(".glider-prev").hide();
          $(this).find(".glider-next").hide();
        }
      });
    }
});